import { render, staticRenderFns } from "./ReasonsDetalizationAllTimeCountsPanel.vue?vue&type=template&id=4b15df0e&scoped=true&"
import script from "./ReasonsDetalizationAllTimeCountsPanel.vue?vue&type=script&lang=js&"
export * from "./ReasonsDetalizationAllTimeCountsPanel.vue?vue&type=script&lang=js&"
import style0 from "./ReasonsDetalizationAllTimeCountsPanel.vue?vue&type=style&index=0&id=4b15df0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b15df0e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b15df0e')) {
      api.createRecord('4b15df0e', component.options)
    } else {
      api.reload('4b15df0e', component.options)
    }
    module.hot.accept("./ReasonsDetalizationAllTimeCountsPanel.vue?vue&type=template&id=4b15df0e&scoped=true&", function () {
      api.rerender('4b15df0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/home/ReasonsDetalizationAllTimeCountsPanel.vue"
export default component.exports